module.exports = __webpack_public_path__ + "img/ico-youtube-circle.3f3e9523.svg";